import { Controller } from '@hotwired/stimulus'
import debounce from 'lodash/debounce'

const DEBOUNCE_WAIT = 200
const FETCH_TIMEOUT = 1000

export default class extends Controller {
  static targets = ['output', 'coordinates']

  initialize () {
    this.dispatchMapMoved = debounce(this.dispatchMapMoved.bind(this), DEBOUNCE_WAIT)
    this.dispatchPolygonSelected = debounce(this.dispatchPolygonSelected.bind(this), DEBOUNCE_WAIT)
    this.handleMessage = debounce(this.handleMessage.bind(this), DEBOUNCE_WAIT)
  }

  connect () {
    window.addEventListener('message', this.handleMessage.bind(this))
  }

  handleMessage (event) {
    if (event.data.type === 'travelTo') {
      this.outputTarget.value = JSON.stringify(event.data.payload)
      this.outputTarget.dispatchEvent(new Event('change'))
    }
  }

  dispatchMapMoved () {
    window.parent.postMessage({
      type: 'map:moved',
      payload: this.coordinatesTarget.value
    }, '*')
  }

  dispatchPolygonSelected () {
    const coordinates = JSON.parse(this.coordinatesTarget.value)

    const fetchOptions = {}
    // Only add timeout if AbortSignal.timeout is supported
    if (typeof AbortSignal.timeout === 'function') {
      fetchOptions.signal = AbortSignal.timeout(FETCH_TIMEOUT)
    }

    fetch(`https://data.geopf.fr/geocodage/reverse/?lat=${coordinates.latitude}&lon=${coordinates.longitude}&type=housenumber&limit=1`, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        window.parent.postMessage({
          type: 'polygon:selected',
          payload: JSON.stringify(
            Object.assign(
              coordinates,
              { address: data.features[0]?.properties }
            )
          )
        }, '*')
      })
      .catch(() => {
        // If fetch fails or times out, post message with coordinates only
        window.parent.postMessage({
          type: 'polygon:selected',
          payload: JSON.stringify(coordinates)
        }, '*')
      })
  }

  dispatchMapLoaded () {
    window.parent.postMessage({
      type: 'map:loaded'
    }, '*')
  }
}
